module.exports = __webpack_public_path__ + "static/media/bw_bayerische.a526db25.png";